import React, { useState, useEffect, useCallback } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import NextGame from './components/NextGame';
import TeamSection from './components/TeamSection';
import Gallery from './components/Gallery';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './App.css';

const App = () => {
  const [hasNextGame, setHasNextGame] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const handleGameStatus = useCallback((found) => {
    setHasNextGame(found);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setShowScrollTop(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.snap-in').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero hasNextGame={hasNextGame} />
        <div className="snap-in">
          <Gallery />
        </div>
        <div className="snap-in">
          <TeamSection />
        </div>
        <div className="snap-in">
          <NextGame onGameStatus={handleGameStatus} />
        </div>
        {/* <div className="snap-in">
          <Results />
        </div> */}
        <div className="snap-in">
          <ContactForm />
        </div>
      </main>
      <Footer />

      <button
        className={`scroll-top ${showScrollTop ? 'show' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Scroll to top"
      >
        &#8593;
      </button>
    </div>
  );
};

export default App;
